import sectionItemsSlideB1Css from '../css-snippets/section-items-slide-b1';

const html = `
<style>${sectionItemsSlideB1Css}</style>
<div class="wrapper-container" id="" data-id="unique-id" data-attribute="wrapper-container"
  data-background-color="#ffffff" data-enable-background-image="false" data-top-padding="true"
  data-bottom-padding="true" style="background-color: rgb(255, 255, 255)">
  <div class="container wrapper-content">
    <div data-attribute="header-section" class="header-section">
      <h2>Header Section</h2>
      <p>Imagine sitting under a soft, flickering glow with family, friends, or a glass of wine. Kaliqo turns your patio
        into your favorite part of the home.</p>
    </div>
    <div class="swiper mySwiper-unique-id">
      <div data-attribute="list-item" class="swiper-wrapper">
        <div data-attribute="item" class="swiper-slide">
          <div class="wrap-item">
            <img data-attribute="image"
              src="https://cdn.skyfastimg.com/images/2025/12/23/image-6949f0be0dc8562170bb2576.jpeg?w=500&amp;h=50&amp;q=80"
              alt="">
            <div data-attribute="overlay" data-opacity="0.2" data-background-color="#000000"
              style="background-color: #000000; opacity: 0.2;" class="overlay-item"></div>
            <div data-attribute="text" class="wrap-text">
              <h2>Beautiful lightning. beautiful space.</h2>
              <p>Transform your place into a cozy, welcoming retreat every night.</p>
            </div>
          </div>
        </div>

        <div data-attribute="item" class="swiper-slide">
          <div class="wrap-item">
            <img data-attribute="image"
              src="https://cdn.skyfastimg.com/images/2025/12/23/image-6949f0c85b04dac8ebac2227.jpeg?w=500&amp;h=50&amp;q=80"
              alt="">
            <div data-attribute="overlay" data-opacity="0.2" data-background-color="#000000"
              style="background-color: #000000; opacity: 0.2;" class="overlay-item"></div>
            <div data-attribute="text" class="wrap-text">
              <h3>12 Hours of Light. Zero Maintenance.</h3>
              <p>Enjoy dusk-to-dawn illumination without lifting a finger.</p>
            </div>
          </div>
        </div>

        <div data-attribute="item" class="swiper-slide">
          <div class="wrap-item">
            <img data-attribute="image"
              src="https://cdn.skyfastimg.com/images/2025/12/23/image-6949f0d15aa550eb1c05e558.webp?w=500&amp;h=50&amp;q=80"
              alt="">
            <div data-attribute="overlay" data-opacity="0.5" data-background-color="#000000"
              style="background-color: #000000; opacity: 0.5;" class="overlay-item"></div>
            <div data-attribute="text" class="wrap-text">
              <h3>High-tech LED.</h3>
              <h3>100% solar-powered.</h3>
              <p>Bright, efficient, and eco-friendly lighting you can count on.</p>
            </div>
          </div>
        </div>

        <div data-attribute="item" class="swiper-slide">
          <div class="wrap-item">
            <img data-attribute="image"
              src="https://cdn.skyfastimg.com/images/2025/12/23/image-6949f0da822a1a52f4c34053.webp?w=500&amp;h=50&amp;q=80"
              alt="">
            <div data-attribute="overlay" data-opacity="0.6" data-background-color="#8257e5"
              style="background-color: #8257e5; opacity: 0.6;" class="overlay-item"></div>
            <div data-attribute="text" class="wrap-text">
              <h3><span style="color:hsl(180, 75%, 60%);">Shine in any condition. No cables, no hassle.</span></h3>
              <p>Weatherproof &amp; waterproof design for effortless outdoor lighting anywhere.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination-unique-id swiper-pagination swiper-pagination-custom">
    </div>
    <a data-attribute="button-cta" data-background-color="#281707" data-color="#ffffff" data-show-button="true"
      class="btn-cta" href="#" style="background-color: #281707; color: #ffffff;">SEE BUNDLE OPTIONS</a>
  </div>
</div>


`;

export default html;
